var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#131BEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2826_2659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0605 13.0156H13.9766C11.802 13.0156 10.0391 14.7198 10.0391 16.822V22.1781C10.0391 24.2803 11.802 25.9845 13.9766 25.9845H25.0605C27.2351 25.9845 28.998 24.2803 28.998 22.1781V16.822C28.998 14.7198 27.2351 13.0156 25.0605 13.0156ZM22.3975 19.7606L17.2132 22.1508C17.0751 22.2145 16.9155 22.1172 16.9155 21.9692V17.0394C16.9155 16.8894 17.0793 16.7921 17.2177 16.86L22.402 19.3996C22.5562 19.4751 22.5535 19.6888 22.3975 19.7606Z",
    fill: "#131BEA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2826_2659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 13,
    fill: "white",
    transform: "translate(10 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.5b7b5210a4ae20ff21f51f8770c5f7aa.svg";
export { ForwardRef as ReactComponent };